import { render, staticRenderFns } from "./elEvent.vue?vue&type=template&id=3909cf46&scoped=true&"
import script from "./elEvent.vue?vue&type=script&lang=js&"
export * from "./elEvent.vue?vue&type=script&lang=js&"
import style0 from "./elEvent.vue?vue&type=style&index=0&id=3909cf46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3909cf46",
  null
  
)

export default component.exports